import { render, staticRenderFns } from "./ShipmentShareLinkModal.vue?vue&type=template&id=d2c059bc&"
import script from "./ShipmentShareLinkModal.vue?vue&type=script&lang=js&"
export * from "./ShipmentShareLinkModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports